<h2 class="flex items-center gap-2 text-2xl px-6 pt-4">
  <mat-icon>lock</mat-icon>
  Change Password
</h2>
<mat-dialog-content class="max-w-md">
  @if (isSubmitting$ | async) {
    <div
      class="flex justify-center items-center absolute top-0 left-0 w-full h-full bg-white/70 z-10"
    >
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        diameter="50"
      ></mat-progress-spinner>
    </div>
  }
  <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-2">
    <div class="flex w-full flex-row">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Current password</mat-label>
        <input
          matInput
          [type]="hideOld ? 'password' : 'text'"
          formControlName="oldPassword"
          autocomplete="current-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideOld = !hideOld"
        >
          <mat-icon>{{ hideOld ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (form.controls.oldPassword.invalid) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
    </div>
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>New password</mat-label>
      <input
        matInput
        [type]="hideNew ? 'password' : 'text'"
        formControlName="newPassword"
        autocomplete="new-password"
        aria-describedby="pw-req"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideNew = !hideNew"
      >
        <mat-icon>{{ hideNew ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      <mat-hint>Follow the requirements below</mat-hint>
      @if (form.controls.newPassword.hasError('required')) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>

    <div id="pw-req" class="rounded-lg bg-gray-50 p-3" aria-live="polite">
      <div class="font-medium mb-1">Password requirements</div>
      <ul class="space-y-1 text-xs">
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.length"
            [class.text-gray-400]="!req.length"
            >check_circle</mat-icon
          >
          At least 8 characters
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.lower"
            [class.text-gray-400]="!req.lower"
            >check_circle</mat-icon
          >
          A lowercase letter
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.upper"
            [class.text-gray-400]="!req.upper"
            >check_circle</mat-icon
          >
          An uppercase letter
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.number"
            [class.text-gray-400]="!req.number"
            >check_circle</mat-icon
          >
          A number
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class.text-green-600]="req.symbol"
            [class.text-gray-400]="!req.symbol"
            >check_circle</mat-icon
          >
          A symbol
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class]="
              req.noUsernamePart && form.controls.newPassword.value.length > 3
                ? 'text-green-600'
                : 'text-gray-400'
            "
          >
            check_circle</mat-icon
          >
          No parts of your username
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class]="
              req.noFirstName && form.controls.newPassword.value.length > 3
                ? 'text-green-600'
                : 'text-gray-400'
            "
            >check_circle</mat-icon
          >
          Does not include your first name
        </li>
        <li class="flex items-center gap-2">
          <mat-icon
            [class]="
              req.noLastName && form.controls.newPassword.value.length > 3
                ? 'text-green-600'
                : 'text-gray-400'
            "
            >check_circle</mat-icon
          >
          Does not include your last name
        </li>
        <li
          class="flex gap-2 italic text-blue-400 pt-2 mt-2 border-t-2 border-gray-2"
        >
          <mat-icon class="text-blue-400 !w-6">info</mat-icon>
          <div class="flex flex-col">
            Can’t match your last 4 passwords
            <span>(checked on save)</span>
          </div>
        </li>
      </ul>
    </div>

    <!-- Confirm field stays below -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Confirm new password</mat-label>
      <input
        matInput
        [type]="hideConf ? 'password' : 'text'"
        formControlName="confirm"
        autocomplete="new-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideConf = !hideConf"
      >
        <mat-icon>{{ hideConf ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      @if (form.hasError('mismatch')) {
        <mat-error>Passwords don’t match</mat-error>
      }
    </mat-form-field>

    @if (errorMessage) {
      <mat-error class="block mt-2">{{ errorMessage }}</mat-error>
    }

    <mat-dialog-actions>
      <div class="flex justify-end w-full gap-2">
        <button
          class="flex items-center bg-gray-100 hover:bg-gray-300 px-4 py-2 rounded-lg shadow-sm"
          mat-dialog-close
        >
          Cancel
        </button>
        <button
          class="flex items-center text-white bg-cobalt-500 hover:bg-cobalt-400 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400 px-4 py-2 rounded-lg shadow-sm"
          type="submit"
          [disabled]="(isSubmitting$ | async) || form.invalid"
        >
          {{ (isSubmitting$ | async) ? 'Saving…' : 'Change password' }}
        </button>
      </div>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
